import { useLocation } from "react-router-dom";
import ResetPasswordForm from "../../components/AuthActions/ResetPasswordForm";

// Legacy route kept for back-compat with any password-reset links already in the
// wild. New links point at /auth/action; both render the same form.
const ResetPassword = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const oobCode = params.get("oobCode");

  return <ResetPasswordForm oobCode={oobCode} />;
};

export default ResetPassword;
